import { createAction } from '@ngrx/store';

export const LoggedInUser = {
  loaded: createAction('[LOGGED_IN_USER] LOADED', (user: any) => ({ user })),

  clear: createAction('[LOGGED_IN_USER] CLEAR'),
};
